import axios from "axios";
import { useState } from "react";


export default function CreateListModal({ onClose, onCreated }) {

  const [form, setForm] = useState({
    name: "",
    description: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    await axios.post("https://api.ilogically.com/api/users/lists?appToken=87adfacc2dffc65ae172d59a9f0badda", form);
    onCreated();
    onClose();
  };

  return (
    <div style={{ border: "1px solid black", padding: 20 }}>
      <h3>Create List</h3>

      <input
        name="name"
        placeholder="List Name"
        value={form.name}
        onChange={handleChange}
      />

      <br />

      <textarea
        name="description"
        placeholder="Description"
        value={form.description}
        onChange={handleChange}
      />

      <br />

      <button onClick={handleSubmit}>Create</button>
      <button onClick={onClose}>Cancel</button>
    </div>
  );
}